import css from './questionList.module.scss';

import { memo } from 'react';

import Preloader from 'core/ui/Preloader';
import Waypoint from 'core/ui/Waypoint';

import { QuestionItem } from '../QuestionItem';
import useQuestionList from './useQuestionList';

const QuestionList = (
  props: Omit<ReturnType<typeof useQuestionList>, 'onToggleOptions'>
) => {
  const {
    questions,
    test,
    onChangeQuestion,
    onRemoveQuestion,
    isFetching,
    fetchMore,
  } = props;

  return (
    <div className={css.list}>
      {test &&
        questions.map((question, idx) => (
          <QuestionItem
            key={question.uid}
            test={test}
            idx={idx}
            question={question}
            onChangeQuestion={onChangeQuestion}
            onRemoveQuestion={onRemoveQuestion}
            showOptions={props.showOptions}
          />
        ))}
      <Waypoint onTrigger={fetchMore} />
      {isFetching && (
        <div className={css.preloaderWrapper}>
          <Preloader />
        </div>
      )}
      {!isFetching && !questions.length && 'Nothing has been found :('}
    </div>
  );
};

export default memo(QuestionList);
